import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const MiniTaskEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
          <Icon name="CheckSquare" size={20} color="var(--color-success)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Mini Görev İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Kullanıcıların tamamlayabileceği basit bir görev tanımlayın
          </p>
        </div>
      </div>
      <Input
        label="Görev Başlığı"
        type="text"
        placeholder="Örn: Bugünün Güvenlik Kontrolü"
        value={content?.title || ''}
        onChange={(e) => handleChange('title', e?.target?.value)}
        required
        description="Görevin kısa ve çekici başlığı"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Görev Açıklaması
          <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-32 md:min-h-40"
          placeholder="Görevin detaylarını açıklayın..."
          value={content?.description || ''}
          onChange={(e) => handleChange('description', e?.target?.value)}
          required
        />
        <p className="caption text-muted-foreground mt-2">
          Kullanıcının ne yapması gerektiğini net bir şekilde açıklayın
        </p>
      </div>
      <Input
        label="Tamamlama Mesajı"
        type="text"
        placeholder="Örn: Harika! Güvenli sürüş için teşekkürler"
        value={content?.completionMessage || ''}
        onChange={(e) => handleChange('completionMessage', e?.target?.value)}
        description="Görev tamamlandığında gösterilecek mesaj"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 rounded-lg bg-muted border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-foreground">Görev Örnekleri</span>
          </div>
          <ul className="caption text-muted-foreground space-y-1">
            <li>• Emniyet kemerini kontrol et</li>
            <li>• Lastik basıncını ölç</li>
            <li>• Ayna ayarlarını kontrol et</li>
          </ul>
        </div>

        <div className="p-4 rounded-lg bg-success/10 border border-success/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Info" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-foreground">İpucu</span>
          </div>
          <p className="caption text-muted-foreground">
            Görevler basit, hızlı tamamlanabilir ve trafik güvenliği ile ilgili olmalıdır
          </p>
        </div>
      </div>
    </div>
  );
};

export default MiniTaskEditor;